// extracted by mini-css-extract-plugin
export const header = "ProductItem-module--header--1_euY";